import { render } from "./TeamSpartacusPage.vue?vue&type=template&id=d46cdce2"
import script from "./TeamSpartacusPage.vue?vue&type=script&lang=js"
export * from "./TeamSpartacusPage.vue?vue&type=script&lang=js"

import "./TeamSpartacusPage.vue?vue&type=style&index=0&id=d46cdce2&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__